enum VehicleAccessType {
    None	= 0,
    Bicycle	= 1,
    MotorcycleProvisionalLicense= 2,
    MotorcycleFullLicense	= 3,
    Car2Seats	= 11,
    Car3Seats	= 12,
    Car4Seats	= 13,
    Car5Seats	= 14,
    Car6Seats	= 15,
    Car7Seats	= 16,
}

export default VehicleAccessType;